import React, { useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { history } from 'src/App'
import DemoFinished from 'src/content/Demo/DemoFinished'
import { loadingSelector } from 'src/selectors/loading.selector'
import { actionTypes as companyActions } from 'src/actions/company.actions'
import { AccountDeactivated } from 'src/components/toolbar/AccountDeactivated'
import { ToolBar } from 'src/components/toolbar/ToolBar'
import SideBar from 'src/components/sidebar/SideBar'
import { useFirebaseSession } from 'src/components/FirebaseProvider/FirebaseProvider'
import { Loading } from 'src/components'

const defaulterRoutes = [
  '/planes',
  '/distribucion/planes',
  '/perfil',
  '/informacion',
  '/checkout',
]

type Props = {
  isDefaulter: boolean
  isTest: boolean
  isOwner: boolean
  children?: React.ReactNode
  isActive: boolean
}
const SecuredContent: React.FC<Props> = ({
  isDefaulter,
  isTest,
  isOwner,
  children,
  isActive,
}) => {
  const { isSignedIn, isSessionLoading } = useFirebaseSession()

  useEffect(() => {
    if (!isSignedIn && isSessionLoading === false) {
      window.location.href = '/login'
    }
  }, [isSignedIn, isSessionLoading])

  const loading = useSelector(state =>
    loadingSelector([companyActions.CURRENT_COMPANY])(state),
  )

  if (!isSignedIn) {
    return <></>
  }

  return (
    <div role="main" style={{ flex: 1 }}>
      <ToolBar isSignedIn={isSignedIn} />

      {defaulterRoutes.every(route => !history.location.pathname.startsWith(route)) && (
        <AccountDeactivated inactive={!isActive} />
      )}
      {!loading &&
      isDefaulter &&
      isActive &&
      defaulterRoutes.every(route => !history.location.pathname.startsWith(route)) ? (
        <div className={'main-content demo'}>
          <DemoFinished isOwner={isOwner} isTest={isTest} />
        </div>
      ) : (
        children
      )}
      <SideBar isSignedIn={isSignedIn} />
    </div>
  )
}

export default SecuredContent
